import React, { useState } from 'react';
import { Box, Button, Modal, Typography, Table, TableBody, TableCell, TableHead, TableRow, Paper, TableContainer } from '@mui/material';
import useStyles from '../../../../styles/global-mui.js';
import { useNavigate } from 'react-router-dom'; // Pour rediriger vers la page d'édition
import { getUserProvider } from '../../../../actions/auth.js'; // Pour obtenir le provider de l'utilisateur
import { usePermissions } from '../../../../permissions/usePermissions.js';
import { PERMISSIONS } from '../../../../permissions/permissionKeys.js';
import { Can } from '../../../../permissions/Can.js';
import DsasButton from '../../../components/DsasButton/DsasButton.js';

const TeamCheckModal = ({ open, onClose, results, onSelectOtherTeam, onConfirmNone, actualProvider = getUserProvider() }) => {
  const navigate = useNavigate();

  const handleSelectMyTeam = (teamId) => {
    navigate(`/sports/teams/create/${teamId}`);
  };

  const handleSelectOtherTeam = (team) => {
    onSelectOtherTeam(team);
    onClose();
  };

  const { getPermission } = usePermissions();
  const providerPermission = getPermission(PERMISSIONS.SPORT_TEAM_PROVIDER_NAME_DISPLAY);

  const classes = useStyles();

  return (
    <Modal open={open} onClose={onClose}>
      <Paper
        sx={{
          width: '90%', // 90% de la largeur de l'écran
          maxWidth: '600px', // Limite de la largeur maximale
          margin: 'auto',
          marginTop: { xs: '10%', md: '5%' }, // Gérer la marge en fonction de la taille de l'écran
          maxHeight: '90vh', // Limite de la hauteur
          overflowY: 'auto', // Activer le défilement si le contenu dépasse la hauteur
          boxSizing: 'border-box',
        }}
      >

        <Box className='medium-padding'>
          {/* <Typography variant="h6" gutterBottom>Vérification des équipes existantes</Typography> */}
          <Box className='centered-wrapper'>
            <h3 className='page-title'>Vérification des équipes existantes</h3>
          </Box>
          
          <Box className='medium-padding'>
          {/* Vos équipes */}
          <h5 className='page-title'>Vos équipes</h5>
       

        {!results
                .filter((team) => team.provider === actualProvider).length ?
                <Typography variant="subtitle1">Aucune de vos équipes ne correspond à la recherche</Typography>
                :
                (
                <TableContainer sx={{ maxWidth: '100%', overflowX: 'auto' }}>
                          <Table className={classes.customTable} size="small" sx={{ minWidth: '100%' }}>
                            <TableHead>
                              <TableRow>
                                <TableCell>Nom</TableCell>
                                <TableCell>Discipline</TableCell>
                                <TableCell>Compétition(s)</TableCell>
                                <TableCell>Actions</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {results
                                .filter((team) => team.provider === actualProvider)
                                .map((team) => (
                                  <TableRow key={team._id}>
                                    <TableCell>{team.name}</TableCell>
                                    <TableCell>{team.discipline}</TableCell>
                                    <TableCell>{team.competitions.map((competition) => competition.name).join(', ')}</TableCell>
                                    <TableCell>
                                      <Button size="small" variant="contained" onClick={() => handleSelectMyTeam(team._id)}>
                                        Modifier
                                      </Button>
                                    </TableCell>
                                  </TableRow>
                                ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                )
        }
        </Box>
        <Box className='medium-padding'>

       {/* Les autres équipes */}
        <h5 className='page-title'>Nos suggestions d'équipes</h5>
       
       
        <TableContainer sx={{ maxWidth: '100%', overflowX: 'auto' }}>
          <Table className={classes.customTable} size="small" sx={{ minWidth: '100%' }}>
            <TableHead>
              <TableRow>
                <TableCell>Nom</TableCell>
                <TableCell>Discipline</TableCell>
                <TableCell>Compétition(s)</TableCell>
                 {providerPermission?.allowed &&
                    <Can permission={PERMISSIONS.SPORT_TEAM_PROVIDER_NAME_DISPLAY}>
                      <TableCell>Provider</TableCell>                          
                    </Can>
                  }
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {results
                .filter((team) => team.provider !== actualProvider)
                .map((team) => (
                  <TableRow key={team._id}>
                    <TableCell>{team.name}</TableCell>
                    <TableCell>{team.discipline}</TableCell>
                    <TableCell>{team.competitions.map((competition) => competition.name).join(', ')}</TableCell>
                     {providerPermission?.allowed &&
                      <Can permission={PERMISSIONS.SPORT_TEAM_PROVIDER_NAME_DISPLAY}>
                        <TableCell>{team.provider}</TableCell>                          
                      </Can>
                      }
                    <TableCell>
                      <Button size="small" variant="contained" onClick={() => handleSelectOtherTeam(team)}>
                        Utiliser
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

         {/* Aucune des équipes ne correspond */}
          <Box sx={{ textAlign: 'center', marginTop: 3 }}>
            <Table className={classes.customTable} size="small" sx={{ minWidth: '100%' }}>
              <TableBody>
                <TableRow>
                  <TableCell className='no-border' sx={{ textAlign: 'center' }}>
                    <Box className='centered-wrapper' sx={{ textAlign: 'center' }} >
                    <DsasButton label="Aucune des équipes ne correspond à mon équipe" onClick={onConfirmNone} variant = 'primary' focused={true}/>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </Box>
      </Box>
      </Paper>
    </Modal>
  );
};

export default TeamCheckModal;
